import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationMethionineCombined from "./index";

const MethylationMethionineWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationMethionineCombined}
    keyControlsId="methylation-methionine-key"
    {...props}
  />
);

export default MethylationMethionineWithToggleKey;
